// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import * as PrimerAssemblyTabView from './PrimerAssemblyTabView';

class GibsonTabOptionsView extends PrimerAssemblyTabView.OptionsView {}

class GibsonTabView extends PrimerAssemblyTabView.TabView {}

export {GibsonTabOptionsView as OptionsView, GibsonTabView as TabView};
